import { get, keyBy } from 'lodash/fp';

import { ProductType } from '../../types/product';
import ProductService from '../../models/product';
import UrlService from '../../models/url';

const getCombinedProductUrl = ({
  cartProduct,
  chosenProduct,
}: {
  cartProduct: ProductType;
  chosenProduct: ProductType;
}) => {
  const productsArray = keyBy((product: { type: string }) => product.type, [cartProduct, chosenProduct]);
  const combinedCartProduct = ProductService.getCombinedCartObject({ ...productsArray } as any);
  const combinedProductId = get('id', combinedCartProduct);
  return UrlService.getProductUrl(combinedProductId);
};

export default getCombinedProductUrl;
